<table class="results-table" [ngStyle]="getStyle()" [class.is-hi-contrast]="isHiContrast()" data-ui-name="Results summary cr table" data-ui-component="results-summary-cr" data-testid="results-summary-cr-results-summary-cr-table">
    <tr data-ui-name="Tr results cr questions headings row" data-ui-component="results-summary-cr" data-testid="results-summary-cr-tr-results-cr-questions-headings-row">
        <th colspan="3"><tra slug="tr_results_cr_questions"></tra></th>
    </tr>
    <tr data-ui-name="Tr results score tr results cr score values row" data-ui-component="results-summary-cr" data-testid="results-summary-cr-tr-results-score-tr-results-cr-score-values-row">
        <td colspan="3">
            <tra slug="tr_results_score"></tra>&nbsp;<tra class="tr_results_cr_score" slug="tr_results_cr_score"></tra>
        </td>
    </tr>
    <tr data-ui-name="Tr results total questions values row" data-ui-component="results-summary-cr" data-testid="results-summary-cr-tr-results-total-questions-values-row">
        <td>
            <tra slug="tr_results_total_questions"></tra>
        </td>
        <td>
            {{numCRQuestions}}
        </td>
        <td>
        </td>
    </tr>
</table>